import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import App from './App';
import { RequireAuth } from './components/RequireAuth';
import { theme } from './theme';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <ThemeProvider theme={theme} defaultMode="system">
      {/* enableColorScheme keeps native form controls in step with the theme */}
      <CssBaseline enableColorScheme />
      <BrowserRouter>
        <RequireAuth>
          <App />
        </RequireAuth>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
